<template>
    <div class="page">
        <ion-grid fixed v-if="userDetails">
            <ion-row class="row-divider"></ion-row>
            <ion-row class="rectangle">
                <ion-col>
                    <ion-row align-items-stretch>
                        <ion-col size="12" size-md="3">
                            <ion-label class="section-item" position="stacked">User Name</ion-label>
                            <div class="section-desc margin-top-10 select-cahrger-station">{{ userDetails.userName }}</div>
                        </ion-col>
                        <ion-col size="12" size-md="3">
                            <ion-label class="section-item" position="stacked">User mobile or Email ID</ion-label>
                            <div class="section-desc margin-top-10 select-cahrger-station">{{ userDetails.emailOrMobile }}</div>
                        </ion-col>
                        <ion-col size="12" size-md="3">
                            <ion-label class="section-item" position="stacked">User Role</ion-label>
                            <div class="section-desc margin-top-10 select-cahrger-station">{{ userDetails.roleId }}</div>
                        </ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>
        </ion-grid>
        <div class="spinner">
            <ion-spinner v-if="loaderTab"></ion-spinner>
        </div>
    </div>
</template>


<script>
import { defineComponent } from "vue";
import { IonButton, IonCol, IonGrid, IonLabel, IonRow, IonInput, IonSelect, IonSelectOption, IonFabButton } from "@ionic/vue";
import datepicker from 'vue3-datepicker';
import { ToastUtils } from "../../util/toast-utils";
import { AdminService } from "@/service/admin/admin.service";
import { migratedTryParseServiceError } from "../../service";
import { add, trash, timeOutline } from 'ionicons/icons';
import moment from "moment";

export default defineComponent({
    name: 'UserDetails',
    components:{
        IonGrid, IonRow, IonCol, IonButton, IonLabel, IonInput, datepicker, IonSelect, IonSelectOption, IonFabButton
    },
    // name: 'UserDetails',
    emits: ['user-loaded'],

    data(){
        return{
            add, 
            userDetails: {}
        }
    },
    async mounted() {
        this.userDetails = JSON.parse(localStorage.getItem('selectedUserDetail'));
        
        this.$emit('user-loaded', this.userDetails);

        this.userDetails = await new AdminService().getUserDetails();
    },
    methods: {
        changeDateFormatWithoutTime(dateValue) {
            if(dateValue != null) {
                return moment(dateValue).format('DD/MMM/YYYY')
            }
        },

        changeDateFormat(dateValue) {
            return moment(dateValue).format('HH:mm')
        },
    }
})
</script>

<style scoped>
.line-style {
    border-top: 1px solid #041648 !important;
  margin: 0px;
  opacity: 1;
}

.section-item {
    font-size: 14px;
}
</style>